/**
 * Farm & Acre Co - File Upload Solution
 *
 * Uploads customer files to Uploadcare CDN for order processing.
 * Handles both tag photo uploads and QLD DPI form uploads.
 * Note: Shopify themes cannot upload files directly to Shopify CDN without a custom app.
 */

(function () {
  'use strict';

  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
  const UPLOADCARE_PUBLIC_KEY = '725538c753a9d9ec0c41';

  function initFileUpload() {
    const fileInputs = document.querySelectorAll('.allflex-field__file');
    fileInputs.forEach((input) => {
      input.addEventListener('change', handleFileSelect);
    });
  }

  async function handleFileSelect(event) {
    const file = event.target.files[0];
    if (!file) return;

    const fieldWrapper = event.target.closest('.allflex-field');
    const nameInput = fieldWrapper.querySelector('[data-upload-role="filename"]');
    const urlInput = fieldWrapper.querySelector('[data-upload-role="url"]');
    const statusEl = fieldWrapper.querySelector('.allflex-field__upload-status');
    const errorEl = fieldWrapper.querySelector('.allflex-field__error');

    // Clear previous errors
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('allflex-field__error--visible');
    }

    // Validate file size
    if (file.size > MAX_FILE_SIZE) {
      showError(errorEl, 'File size exceeds 10MB limit');
      event.target.value = '';
      return;
    }

    // Validate file type
    if (!file.type.match(/^image\/(jpeg|jpg|png|gif|webp)|application\/pdf$/)) {
      showError(errorEl, 'Please upload an image (JPG, PNG, GIF, WEBP) or PDF file');
      event.target.value = '';
      return;
    }

    // Show uploading status
    if (statusEl) {
      statusEl.style.display = 'block';
      var progressEl = statusEl.querySelector('.allflex-field__upload-progress');
      if (progressEl) progressEl.textContent = 'Uploading ' + file.name + '...';
    }

    try {
      var uploadUrl = await uploadToUploadcare(file);

      if (uploadUrl) {
        // Store filename (visible in cart) and URL (hidden, visible in admin)
        if (nameInput) nameInput.value = file.name;
        if (urlInput) urlInput.value = uploadUrl;

        // Update status
        if (statusEl) {
          var progressEl = statusEl.querySelector('.allflex-field__upload-progress');
          if (progressEl) progressEl.innerHTML = '<strong>' + file.name + '</strong> uploaded successfully';
        }
      } else {
        throw new Error('Upload failed');
      }

    } catch (error) {
      console.error('Upload failed:', error);
      showError(errorEl, 'Upload failed. Please try again or describe your file in the comments field.');
      event.target.value = '';

      if (statusEl) {
        statusEl.style.display = 'none';
      }
    }
  }

  async function uploadToUploadcare(file) {
    var formData = new FormData();
    formData.append('UPLOADCARE_PUB_KEY', UPLOADCARE_PUBLIC_KEY);
    formData.append('UPLOADCARE_STORE', '1');
    formData.append('file', file);

    var response = await fetch('https://upload.uploadcare.com/base/', {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error('Uploadcare upload failed');
    }

    var data = await response.json();

    if (data.file) {
      return 'https://2uodvig8qq.ucarecd.net/' + data.file + '/';
    }

    throw new Error('No file URL in Uploadcare response');
  }

  function showError(errorEl, message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.classList.add('allflex-field__error--visible');
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFileUpload);
  } else {
    initFileUpload();
  }
})();
